import * as React from 'react';
import Badge from '@material-ui/core/Badge';
import NotificationIcon from '~/assets/images/notification-icon.svg';
import NotificationIconRead from '~/assets/images/notification-icon-read.svg';

export default function BadgeNotification(props) {

  return (
    <Badge
      color={props.readValue === 0 ? "primary" : "error"}
      badgeContent={props.readValue}
      style={{ height: '50%', margin: `${props.readValue === 0 ? '5px' : '15px'} 0px 0px 20px` }}
    >
      {props.readValue === 0 ? 
      <img src={NotificationIcon} style={{ width: '70%'}} />
      : <img src={NotificationIconRead} style={{ width: '70%'}} />}
    </Badge>
  );
}
